module.exports = __webpack_public_path__ + "img/roaming-pin.54f6e5fe.svg";